module.exports = __webpack_public_path__ + "img/ic_note_line.2eb54113.svg";